import React, { useState } from "react";
import { DetailsPage, HelpPage, HomePage, NotificationsPage, PlantationsPage, ProfilePage } from "./pages/HomePage";
import { ArPage, CountPage, GeneralInfoPage, GrowthPage, LossPage, MappingPage, PlotsPage, ReviewPage, TypeSelectionPage } from "./pages/FieldFlowPage";
import { MapExplorerPage, OfflinePage, QualityPage, StripMappingPage, TrendPage, ValidatorPage } from "./pages/OperationsPage";
import { AdminPage, CitizenPage, DistrictPage, ManagementPage, RoleLoginPage, RoleSelectPage, RoleSplashPage, UpazilaPage, ValidatorHomePage } from "./pages/RolePages";
import { AuditPage, DbHPage, GapFillingPage, InvalidCountPage, LocationPage, MasterDataPage, OfflineSavePage, PhotoPage, ReportsPage, SubmissionPage, UsersPage, ValidatorDetailPage } from "./pages/SupportPages";
import { FieldMetricPage } from "./pages/FieldMetricPages";
import { type UserRole } from "./data/roleData";
type Screen = "splash" | "roleSelect" | "roleLogin" | "home" | "type" | "general" | "location" | "mapping" | "plots" | "count" | "invalidCount" | "growth" | "ar" | "dbh" | "photo" | "loss" | "review" | "submission" | "offlineSave" | "offline" | "plantations" | "details" | "trend" | "mapExplorer" | "validator" | "validatorHome" | "validatorDetail" | "quality" | "notifications" | "help" | "profile" | "strip" | "district" | "upazila" | "management" | "nationalMap" | "analytics" | "admin" | "citizen" | "reports" | "users" | "masterData" | "audit" | "gapFilling" | "myPlantations" | "monthlyMonitoring" | "pendingValidation" | "work";
export function App() {
  const [screen, setScreen] = useState<Screen>("splash");
  const [role, setRole] = useState<UserRole>("field");
  const go = (next: string) => setScreen(next === "work" ? "offline" : next as Screen);
  const renderScreen = () => {
    switch (screen) {
      case "splash":
        return <RoleSplashPage go={go} data-id="element-0" data-mp="nvar1p5ifbf2" />;
      case "roleSelect":
        return <RoleSelectPage go={go} setRole={setRole} data-id="element-1" data-mp="stuexv3nyxa2" />;
      case "roleLogin":
        return <RoleLoginPage go={go} role={role} data-id="element-2" data-mp="36hzxgtw5a5z" />;
      case "home":
        return <HomePage go={go} data-id="element-3" data-mp="34nb3rfi0xwm" />;
      case "type":
        return <TypeSelectionPage go={go} data-id="element-4" data-mp="3ud1dv4v0xg8i" />;
      case "general":
        return <GeneralInfoPage go={go} data-id="element-5" data-mp="3ucj91juaptoz" />;
      case "location":
        return <LocationPage go={go} data-id="element-6" data-mp="d4xpvgh6mddw" />;
      case "mapping":
        return <MappingPage go={go} data-id="element-7" data-mp="d2bibguajxvo" />;
      case "plots":
        return <PlotsPage go={go} data-id="element-8" data-mp="86mfn4mz60v5" />;
      case "count":
        return <CountPage go={go} data-id="element-9" data-mp="83qgxe3az85n" />;
      case "invalidCount":
        return <InvalidCountPage go={go} data-id="element-10" data-mp="3gmfvdh9hf8b5" />;
      case "growth":
        return <GrowthPage go={go} data-id="element-11" data-mp="3bmbevr8kqdkx" />;
      case "ar":
        return <ArPage go={go} data-id="element-12" data-mp="3bnmh3mmdfd9x" />;
      case "dbh":
        return <DbHPage go={go} data-id="element-13" data-mp="3bkgss9lkgff9" />;
      case "photo":
        return <PhotoPage go={go} data-id="element-14" data-mp="3qc96yi9mjnfe" />;
      case "loss":
        return <LossPage go={go} data-id="element-15" data-mp="3qdafog363xty" />;
      case "review":
        return <ReviewPage go={go} data-id="element-16" data-mp="3lk7q0j1ih8j1" />;
      case "submission":
        return <SubmissionPage go={go} data-id="element-17" data-mp="3limsckjwh9gy" />;
      case "offlineSave":
        return <OfflineSavePage go={go} data-id="element-18" data-mp="2xtlqjg5kowkn" />;
      case "offline":
        return <OfflinePage go={go} data-id="element-19" data-mp="2sw21dl7c6zdx" />;
      case "plantations":
        return <PlantationsPage go={go} data-id="element-20" data-mp="2svaf50zmqe0b" />;
      case "details":
        return <DetailsPage go={go} data-id="element-21" data-mp="18d9c849dngr4" />;
      case "trend":
        return <TrendPage go={go} data-id="element-22" data-mp="18cggrzfvcdoa" />;
      case "mapExplorer":
        return <MapExplorerPage go={go} data-id="element-23" data-mp="1d4rf4xuynreq" />;
      case "validator":
        return <ValidatorPage go={go} data-id="element-24" data-mp="1d6kk88pxe3km" />;
      case "validatorHome":
        return <ValidatorHomePage go={go} data-id="element-25" data-mp="ygwlnf94pj0l" />;
      case "validatorDetail":
        return <ValidatorDetailPage go={go} data-id="element-26" data-mp="13eevd7uz029n" />;
      case "quality":
        return <QualityPage go={go} data-id="element-27" data-mp="13ey726u11uf8" />;
      case "notifications":
        return <NotificationsPage go={go} data-id="element-28" data-mp="1r3zhu0qc1hno" />;
      case "help":
        return <HelpPage go={go} data-id="element-29" data-mp="1r2g0s7wur2ku" />;
      case "profile":
        return <ProfilePage go={go} data-id="element-30" data-mp="1w2aq470zbk3s" />;
      case "strip":
        return <StripMappingPage go={go} data-id="element-31" data-mp="1w0zmc77jacco" />;
      case "district":
        return <DistrictPage go={go} data-id="element-32" data-mp="1i2sw9d8ttgnk" />;
      case "upazila":
        return <UpazilaPage go={go} data-id="element-33" data-mp="1m5617zfr1aja" />;
      case "management":
      case "nationalMap":
      case "analytics":
        return <ManagementPage go={go} data-id="element-34" data-mp="6ofdunwudtex" />;
      case "admin":
        return <AdminPage go={go} data-id="element-35" data-mp="6nmggdjrwg9g" />;
      case "citizen":
        return <CitizenPage go={go} data-id="element-36" data-mp="aq0ywwjj5e07" />;
      case "reports":
        return <ReportsPage go={go} data-id="element-37" data-mp="aqslxiz2a3ev" />;
      case "users":
        return <UsersPage go={go} data-id="element-38" data-mp="qwvos6dw892o" />;
      case "masterData":
        return <MasterDataPage go={go} data-id="element-39" data-mp="qyq9pkp6016r" />;
      case "audit":
        return <AuditPage go={go} data-id="element-40" data-mp="m6p066jdsokf" />;
      case "gapFilling":
        return <GapFillingPage go={go} data-id="element-41" data-mp="m547kmgmnfp7" />;
      case "myPlantations":
        return <FieldMetricPage mode="myPlantations" go={go} data-id="element-42" data-mp="h6kmeo9uy7xw" />;
      case "monthlyMonitoring":
        return <FieldMetricPage mode="monthlyMonitoring" go={go} data-id="element-43" data-mp="c8rfft0qd9wk" />;
      case "pendingValidation":
        return <FieldMetricPage mode="pendingValidation" go={go} data-id="element-44" data-mp="19vrgnb2a4bdc" />;
      default:
        return <HomePage go={go} data-id="element-45" data-mp="19tx4om8zjtle" />;
    }
  };
  return <div className="min-h-screen w-full bg-[#dfe9e1] py-0 text-[#1F2D24] sm:flex sm:items-center sm:justify-center sm:p-6" data-id="element-46" data-mp="14wna6s6qorqp"><div className="relative min-h-screen w-full overflow-hidden bg-[#EEF7F0] sm:min-h-[780px] sm:max-w-[390px] sm:rounded-[28px] sm:shadow-[0_20px_60px_rgba(15,81,50,.24)]" data-id="element-47" data-mp="zwsfsenr9k0w">{renderScreen()}</div></div>;
}